export const addNotification = (text, style) => ({
  type: 'ADD_NOTIFICATION',
  text,
  style
})
export const removeNotification = id => ({
  type: 'REMOVE_NOTIFICATION',
  id
})


// WEBPACK FOOTER //
// ./src/actions/notification.js